import ko from "knockout";

ko.bindingHandlers.tooltip = {
  init: function (element, valueAccessor) {
    let tooltip;
    const value = ko.unwrap(valueAccessor());

    function removeTooltip() {
      if (tooltip) {
        tooltip.style.opacity = "0";
        setTimeout(() => {
          if (tooltip && tooltip.parentNode) {
            tooltip.parentNode.removeChild(tooltip);
            tooltip = null;
          }
        }, 200);
      }
    }

    function updateTooltipPosition(e) {
      if (tooltip) {
        tooltip.style.left = (e.clientX + 10) + "px";
        tooltip.style.top = (e.clientY + 10) + "px";
      }
    }

    element.addEventListener("mouseenter", (e) => {
      tooltip = document.createElement("div");
      tooltip.className = "tooltip";
      tooltip.style.position = "fixed";
      tooltip.style.zIndex = "9999";
      tooltip.style.background = "black";
      tooltip.style.color = "white";
      tooltip.style.padding = "4px 6px 0 4px";
      tooltip.style.borderRadius = "4px";
      tooltip.style.pointerEvents = "none";
      tooltip.style.whiteSpace = "nowrap";
      tooltip.style.opacity = "0";
      tooltip.style.transition = "opacity 0.2s ease";
      tooltip.innerHTML = value;

      document.body.appendChild(tooltip);

      updateTooltipPosition(e);

      requestAnimationFrame(() => {
        tooltip.style.opacity = "1";
      });
    });

    element.addEventListener("mousemove", (e) => {
      updateTooltipPosition(e);
    });

    element.addEventListener("mouseleave", removeTooltip);

    ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
      removeTooltip();
    });
  },
};
